import styled from "styled-components";
import { AreaButton } from "@/main/components/shared/styles";

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	height: fit-content;
`;

export const SealArea = styled(AreaButton)<{ $offsetRight: number; $height: number }>`
	position: absolute;
	top: 0;
	right: calc(${({ $offsetRight }) => $offsetRight}px + 1rem);
	height: ${({ $height }) => $height}px;
	align-items: center;
	z-index: auto;
`;
